import React from "react"
import Router, { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import useTranslation from "next-translate/useTranslation"
import { connect } from "react-redux"
import { getTextSearchMessage } from 'SRC/modules/vehicleParts/list/selectors/getTextSearchMessage'
import { getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

import translations from '../../../../../../public/data/translations.json'

const TextSearch = ({ textSearchMessage }) => {
	const [text, setText] = React.useState('')

	const router = useRouter()

	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	React.useEffect(() => {
		if (router?.query?.['text-filter']) {
			setText(router.query['text-filter'])
		}
	}, [router?.query?.['text-filter']])

	const textValue = ''

	const submit = () => {
		if (!text) return
		console.log('submit', text)

		const urlFromValues = getUrl({ 'text-filter': text }, locale)
		console.log('urlFromValues', urlFromValues)
		const href = urlFromValues.href
		const as = urlFromValues.asUrl

		Router.push(href, as)
	}

	const className = textSearchMessage ? 'vehicle-parts-text-search vehicle-parts-text-search--error' : 'vehicle-parts-text-search'

	return (
		<>
			<form
				onSubmit={e => { e.preventDefault() }}
				className={className}
			>
				<input
					type='text'
					placeholder={t('vehicle_parts_text_search_placeholder')}
					onChange={e => {
						const value = e.target.value

						setText(value)
					}}
					defaultValue={textValue}
					value={text}
					maxLength={50}
				/>

				<button className='ads-search__button' onClick={submit}>
					<i className='ogl-header-ico ico-pretraga-text-search-lupa ico' />
				</button>

			</form>

			{textSearchMessage && <div className='vehicle-parts-text-search__message'>{textSearchMessage}</div>}
		</>
	)
}


TextSearch.propTypes = {
	textSearchMessage: PropTypes.string
}

const mapStateToProps = (state) => ({
	textSearchMessage: getTextSearchMessage(state)
})

export default connect(mapStateToProps)(TextSearch)
